/* eslint-disable max-len */

import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import style from "./style.module.scss";
import Input from "../../../../components/input";

interface Props {
  date: any;
  device: any;
  getLogSensorsPerDateList: any;
  onChangeDate: any;
  onChangeDevice: any;
  queryLogSensorsPerDateList: any;
}

const getColumns = (data: any): Array<string> => Object.keys(JSON.parse(JSON.parse(data)[0].data));

const getRowsData = (data: any): Array<string> => JSON.parse(data);

const getRowData = (data: any): Array<string> => Object.keys(JSON.parse(data)).map((key: any) => JSON.parse(data)[key]);

const Main = (props: Props): JSX.Element => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <div className={style.dateCardWrapper}>
          <Paper>
            <div className={style.dateWrapper}>
              <div>
                <Input type="date" value={props.date} onChange={(event: any): void => props.onChangeDate(event.target.value)} />
              </div>
              <div>
                <Input type="device" value={props.device} onChange={(event: any): void => props.onChangeDevice(event.target.value)} />
              </div>
            </div>
          </Paper>
        </div>
        <Paper className={style.scrollWrapper}>
          {
            props.queryLogSensorsPerDateList.loading
              ? <div className={style.withPadding}><CircularProgress /></div> :
              (
                <>
                  {
                    (props.queryLogSensorsPerDateList?.data?.logSensorsPerDateList?.data ?? "[]") !== "[]" ? (
                      <div className={style.table}>
                        <table>
                          <thead>
                            <tr>
                              {
                                getColumns(props.queryLogSensorsPerDateList.data.logSensorsPerDateList.data).map((column: string): JSX.Element => (
                                  <th key={"header_" + column}>{column}</th>
                                ))
                              }
                            </tr>
                          </thead>
                          <tbody>
                            {
                              getRowsData(props.queryLogSensorsPerDateList.data.logSensorsPerDateList.data).map((row: any) => (
                                <tr key={`row_${row.id}`}>
                                  {
                                    getRowData(row.data).map((rowData: any, index: number) => (
                                      <td key={"row_data_" + index}>{rowData}</td>
                                    ))
                                  }
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                    ) : <span className={style.withPadding}>Non ci sono dati da mostrare</span>
                  }
                </>
              )
          }
        </Paper>
      </Grid>
    </Grid >
  );
};

export default Main;
